export const getTooltipGridCols = (fileTypes: string[]) => {
  const length = fileTypes?.length ?? 0;
  if (length <= 2) return 1;
  if (length <= 4) return 2;
  if (length <= 6) return 3;
  return 4;
};

export const getTooltipGridColsAndRows = (fileTypes: string[]) => {
  const cols = getTooltipGridCols(fileTypes);
  const rows = Math.ceil(fileTypes.length / cols);

  return { cols, rows };
};
